import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Attending } from '../../model/attending';
import {AttendingScore} from '../../model/attending-score';

@Component({
  selector: 'tx-technician-score',
  templateUrl: './technician-score.component.html',
  styleUrls: ['./technician-score.component.css']
})
export class TechnicianScoreComponent implements OnInit {
  MONITORING_USER_GIVES_SCORE = 'MONITORING_USER_GIVES_SCORE';
  TECHNICIAN_DEFAULT_SCORE = 3;
  _attending: Attending;
  _authenticatedUser: any;
  _modalActions: any;
  @Output() txAttending: EventEmitter<void> = new EventEmitter();
  @Output() txFinish: EventEmitter<void> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set authenticatedUser(authenticatedUser) {
    this._authenticatedUser = authenticatedUser;
  }

  get authenticatedUser() {
    return this._authenticatedUser;
  }

  @Input()
  set modalActions(modalActions) {
    this._modalActions = modalActions;
  }

  get modalActions() {
    return this._modalActions;  }

  closeModal() {
    this.attending.technicianScore = new AttendingScore();
    this.modalActions.emit({ action: 'modal', params: ['close'] });
  }

  setTechnicianScore() {
    if (this.attending.technicianScore.score === undefined) {
      this.attending.technicianScore.score = this.TECHNICIAN_DEFAULT_SCORE;
    }
    this.attending.technicianScore.technician = this.attending.scheduling.technician;
    this.attending.technicianScore.monitoringUser = this.authenticatedUser;
    this.attending.technicianScore.scoreInfo = this.MONITORING_USER_GIVES_SCORE;
    this.txAttending.emit();
    this.txFinish.emit();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/technician-score/technician-score.component.ts